export enum FeeProgramType {
  SURCHARGE = 'SURCHARGE',
  SERVICE_FEE = 'SERVICE_FEE',
  CONVENIENCE_FEE = 'CONVENIENCE_FEE',
  CASH_DISCOUNT = 'CASH_DISCOUNT',
}
